"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractBuilder = void 0;
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var class_transformer_1 = require("class-transformer");
var handle_validation_errors_1 = require("../utils/handle-validation-errors");
var class_validator_1 = require("class-validator");
var AbstractBuilder = (function () {
    function AbstractBuilder() {
        this.data = {};
    }
    AbstractBuilder.prototype.parseJsonObject = function (json, options) {
        if (options === void 0) { options = {}; }
        this.data = Object.assign({}, (0, class_transformer_1.plainToInstance)(this.Model, json, __assign({ excludeExtraneousValues: true }, options)));
        return this;
    };
    AbstractBuilder.prototype.parseJson = function (json, options) {
        if (options === void 0) { options = {}; }
        return this.parseJsonObject(JSON.parse(json), options);
    };
    AbstractBuilder.prototype.build = function (options) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.getValidatedModel((0, class_transformer_1.plainToInstance)(this.Model, this.data), options);
    };
    AbstractBuilder.prototype.buildPartial = function (options) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        options = __assign(__assign({}, options), { skipMissingProperties: true });
        return this.getValidatedModel((0, class_transformer_1.plainToInstance)(this.Model, this.data, {
            excludeDefaultValues: true,
        }), options);
    };
    AbstractBuilder.prototype.buildUnvalidatedPartial = function () {
        return this.buildPartial({ ignoreErrors: true });
    };
    Object.defineProperty(AbstractBuilder.prototype, "isEmpty", {
        get: function () {
            return Object.keys(this.data).length === 0;
        },
        enumerable: false,
        configurable: true
    });
    AbstractBuilder.prototype.equals = function (obj, options) {
        var _a;
        var self = structuredClone(this.data);
        var compareObj = structuredClone(obj.data);
        (_a = options === null || options === void 0 ? void 0 : options.omittingKeys) === null || _a === void 0 ? void 0 : _a.forEach(function (k) {
            delete self[k];
            delete compareObj[k];
        });
        try {
            return (0, fast_deep_equal_1.default)((0, class_transformer_1.instanceToPlain)(self), (0, class_transformer_1.instanceToPlain)(compareObj));
        }
        catch (_b) {
            return false;
        }
    };
    AbstractBuilder.prototype.getValidatedModel = function (model, options) {
        (0, handle_validation_errors_1.handleValidationErrors)((0, class_validator_1.validateSync)(model, options), this.data, options === null || options === void 0 ? void 0 : options.ignoreErrors);
        return model;
    };
    return AbstractBuilder;
}());
exports.AbstractBuilder = AbstractBuilder;
//# sourceMappingURL=abstract-builder.js.map